var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGraphYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0B45CAB-31E2-41D3-A6CF-393B025CBF0E_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid---Expanded",
    transform: "translate(-536.000000, -1355.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(208.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 816.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-4",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(24.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(250.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(55.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Graph_Yellow-16px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4182783 12.4182783,16 8,16 C3.58172174,16 0,12.4182783 0,8 C0,3.58172174 3.58172174,0 8,0 C12.4182783,0 16,3.58172174 16,8 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "8 0 8 8 16 8"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Graph_Yellow-16px.99d0fe0f72773ec497a0e81c7b9b08f2.svg";
export { ForwardRef as ReactComponent };